import $ from "jquery";

const menuOpenClass = "is-open";
const menuTriggerClass = ".js-toggle-branchnav";

function toggleBranchNav() {
  const $nav = $(this).closest(".branchnav");
  $nav.find(".wp-menu").stop().slideToggle(250);
  $nav.toggleClass(menuOpenClass);
  $(this).attr("aria-expanded", $nav.hasClass(menuOpenClass));
}

$(menuTriggerClass).on("click", toggleBranchNav);
